import axios from 'axios'
import config from '../../config'

let FaqApi = {
  mostUseful() {
    return axios.get(config.apiUrl + 'faqs/mostUseful');
  },
  upVote(id) {
    return axios.get(config.apiUrl + 'faqs/rating/up/' + id)
  },
  downVote(id) {
    return axios.get(config.apiUrl + 'faqs/rating/down/' + id);
  },
  getRecommendations(id) {
    return axios.get(config.apiUrl + 'faqs/recommendations/' + id);
  },
  getById(id) {
    return axios.get(config.apiUrl + 'faqs/' + id);
  },
  getCategories() {
    let self = this;
    return axios.get(config.apiUrl + 'faqs/categories')
  },
  getAll() {
    return axios.get(config.apiUrl + 'faqs');
  },
  search(value) {
    return axios.post(config.apiUrl + 'faqs/search', {
      keyword: value
    })
  }
};

export default FaqApi;



// WEBPACK FOOTER //
// ./src/api/Faq/index.js